var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTapByIndexAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4416 27.6542C14.7883 27.6542 14.1575 27.519 13.5493 27.2487C12.941 26.9783 12.4342 26.5841 12.0287 26.066L5.23654 17.4153C5.07885 17.2126 5 16.9873 5 16.7395C5 16.4917 5.09011 16.2776 5.27033 16.0974L5.4055 15.9623C5.72089 15.6243 6.10949 15.416 6.57131 15.3371C7.03313 15.2583 7.46679 15.3315 7.87229 15.5568L11.2177 17.3477V5.01375C11.2177 4.72652 11.3154 4.48576 11.5108 4.29145C11.7063 4.09715 11.9484 4 12.2373 4C12.5263 4 12.7665 4.09715 12.9579 4.29145C13.1494 4.48576 13.2452 4.72652 13.2452 5.01375V12.7858H23.3778C24.5075 12.7858 25.4665 13.1801 26.255 13.9685C27.0434 14.757 27.4377 15.7145 27.4377 16.8408V22.5854C27.4377 24.0047 26.9477 25.2043 25.9677 26.1842C24.9878 27.1642 23.7882 27.6542 22.3689 27.6542H15.4416Z",
    fill: "#3F5065"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.0203,
    y: 4.05078,
    width: 11.5109,
    height: 2.09289,
    fill: "#3F5065"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.0203,
    y: 7.19019,
    width: 7.32511,
    height: 2.09289,
    fill: "#3F5065"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTapByIndexAction);
export default __webpack_public_path__ + "static/media/iconTapByIndexAction.12610919.svg";
export { ForwardRef as ReactComponent };